import { useContext, useState } from 'react';
import styled from 'styled-components';
import { screenLg, screenSm } from 'constants/styles/breakpoints';
import { PopularReportsContext } from 'contexts/reporting';
import SpinnerIMG from 'assets/images/spinner.png';
import { Spin } from 'components/loadings/Spinner';
import ReportCard from './shared/ReportCard';
import GenerateReportModal from './GenerateReportModal';
import ScheduleReportModal from './ScheduleReportModal';

const Container = styled.div`
  display: flex;
  overflow: scroll;
  position: relative;
  gap: 10px;
  padding-bottom: 10px;

  ${screenSm} {
    align-items: stretch;
    height: auto;
    overflow-x: auto;
    gap: 16px;
    padding: 0;
    overscroll-behavior-x: contain;
    -webkit-overflow-scrolling: touch;
    &::-webkit-scrollbar {
      display: none;
    }

    scrollbar-width: none;
  }

  ${screenLg} {
    display: grid;
    height: 436px;
    align-self: stretch;
    grid-template-rows: repeat(3, minmax(0, 1fr));
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`;

const ReportingContentPopular = (): JSX.Element => {
  const { popularReports, fetchingPopularReports } = useContext(PopularReportsContext);
  const [selectedReport, setSelectedReport] = useState(null);
  const [isGenerateReportModalOpen, setIsGenerateReportModalOpen] = useState(false);
  const [isScheduleReportModalOpen, setIsScheduleReportModalOpen] = useState(false);

  const handleGenerateReportClick = (report) => {
    setSelectedReport(report);
    setIsGenerateReportModalOpen(true);
  };

  const handleScheduleReportClick = (report) => {
    setSelectedReport(report);
    setIsScheduleReportModalOpen(true);
  };

  return (
    <Container aria-busy={fetchingPopularReports}>
      {fetchingPopularReports && <Spin src={SpinnerIMG} size="80" zIndex="200" />}
      {!fetchingPopularReports &&
        popularReports &&
        popularReports.map((report) => (
          <ReportCard
            key={report.id}
            report={report}
            onGenerateReport={() => handleGenerateReportClick(report)}
            onScheduleReport={() => handleScheduleReportClick(report)}
            onClick={() => setSelectedReport(report)}
          />
        ))}
      <GenerateReportModal
        close={() => setIsGenerateReportModalOpen(false)}
        isOpen={isGenerateReportModalOpen}
        report={selectedReport}
      />
      {isScheduleReportModalOpen && (
        <ScheduleReportModal
          closeModal={() => setIsScheduleReportModalOpen(false)}
          isPopularReport={true}
          reportDefaultName={selectedReport?.name || ''}
          filtersType={selectedReport?.type || ''}
          reportId={selectedReport?.id || null}
          currentFrequencies={
            selectedReport?.schedules?.map((schedule) => schedule.frequency) || []
          }
        />
      )}
    </Container>
  );
};

export default ReportingContentPopular;
